export const UPDATE_FILTER = 'UPDATE_FILTER';
export const ON_FOCUS_CHANGE = 'ON_FOCUS_CHANGE';

export const COMPANY_REQUEST = 'COMPANY_REQUEST';
export const COMPANY_SUCCESS = 'COMPANY_SUCCESS';
export const COMPANY_ERROR = 'COMPANY_ERROR';

export const TEAM_REQUEST = 'TEAM_REQUEST';
export const TEAM_SUCCESS = 'TEAM_SUCCESS';
export const TEAM_ERROR = 'TEAM_ERROR';

export const TEAM_MEMBER_REQUEST = 'TEAM_MEMBER_REQUEST';
export const TEAM_MEMBER_SUCCESS = 'TEAM_MEMBER_SUCCESS';
export const TEAM_MEMBER_ERROR = 'TEAM_MEMBER_ERROR';

export const PROGRAMS_REQUEST = 'PROGRAMS_REQUEST';
export const PROGRAMS_SUCCESS = 'PROGRAMS_SUCCESS';
export const PROGRAMS_ERROR = 'PROGRAMS_ERROR';

export const COMPANY_MULTI_REQUEST = 'COMPANY_MULTI_REQUEST';
export const COMPANY_MULTI_SUCCESS = 'COMPANY_MULTI_SUCCESS';
export const COMPANY_MULTI_ERROR = 'COMPANY_MULTI_ERROR';

export const REPORTING_GROUP_REQUEST = 'REPORTING_GROUP_REQUEST';
export const REPORTING_GROUP_SUCCESS = 'REPORTING_GROUP_SUCCESS';
export const REPORTING_GROUP_ERROR = 'REPORTING_GROUP_ERROR';

export const SUBSCRIPTION_REQUEST = 'SUBSCRIPTION_REQUEST';
export const SUBSCRIPTION_ERROR = 'SUBSCRIPTION_ERROR';
export const SUBSCRIPTION_FETCH_SUCCESS = 'SUBSCRIPTION_FETCH_SUCCESS';
export const SUBSCRIPTION_FORM_SUCCESS = 'SUBSCRIPTION_FORM_SUCCESS';
export const SUBSCRIPTION_CHANGE = 'SUBSCRIPTION_CHANGE';
